import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Alert, Box, Typography } from 'components/AORedesign';
import { useNewsArticleModal } from 'hooks/useNewsArticleModal';
import NewsArticleModal from 'components/NewsArticles/NewsArticleModal';
import { ANNOUNCEMENT_TYPES } from 'constants/static';
import { hideDashboardAlert, selectAnnouncements } from 'redux/app-store';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    padding: 0,
    flexDirection: 'column',
    gap: '8px',
  },
}));

const DashboardAlerts = () => {
  const { announcements: dashboardAlerts } = useSelector((state) => selectAnnouncements(state, [ANNOUNCEMENT_TYPES.ALERT_URGENT]));
  const { hiddenDashboardAlerts } = useSelector((state) => state.app);

  const dispatch = useDispatch();

  const classes = useStyles();
  // shared news-article modal: fetch-on-open + pdf/doc download branching
  const { openNewsArticle, newsArticleModalProps } = useNewsArticleModal();

  const handleAlertOnClose = (seqId) => {
    // Once the user closes this alert we do not want to show it until their next session
    dispatch(hideDashboardAlert(seqId));
  };

  return (
    <>
      {dashboardAlerts && (
        <Box className={classes.container} mb={3}>
          {dashboardAlerts.map((alert, index) => {
            const showAlert = !hiddenDashboardAlerts[alert.seqId];
            return (
              showAlert && (
                <Box key={`${alert.seqId}-${index}`} my={-2}>
                  <Alert onClose={() => handleAlertOnClose(alert.seqId)} severity="warning" icon={<ErrorOutlineIcon />}>
                    <Box onClick={() => openNewsArticle(alert.seqId, alert.ext)} style={{ cursor: 'pointer' }}>
                      <Typography>{alert.title}</Typography>
                    </Box>
                  </Alert>
                </Box>
              )
            );
          })}
        </Box>
      )}
      <NewsArticleModal {...newsArticleModalProps} />
    </>
  );
};

export default DashboardAlerts;
